export interface EventData {
  data?: any;
}
// Listener represents event listener.
export interface Listener {
  (name: string, data?: EventData): void;
}

// EventBus is a simple non cohesive event bus contract.
export interface EventBus {
  subscribe(name: string, l: Listener): void;
  unsubscribe(name: string, l: Listener): void;
  publish(name: string, data?: EventData): void;
}

class EventBusImpl implements EventBus {
  private listeners: {
    [key: string]: Listener[];
  } = {};

  subscribe(name: string, l: Listener) {
    if (!this.listeners[name]) {
      this.listeners[name] = [];
    }

    this.listeners[name].push(l);
  }

  unsubscribe(name: string, l: Listener) {
    if (!this.listeners[name]) {
      return;
    }
    this.listeners[name] = this.listeners[name].filter((item) => item !== l);
  }

  publish(name: string, d?: EventData) {
    const listnrs = this.listeners[name] ?? [];

    // TODO should run as promises to introduce async behavior?
    listnrs.forEach((l) => l(name, d));
  }
}

const eventBus: EventBus = new EventBusImpl();

// export singleton.
export default eventBus;
